export const CourseSchedulerConstant = {
  scheduledSectionFormId: 'scheduled-sections-form',
  waitListConfirmationSectionFormId: 'waitlist-section-prompt-form',
  swapConfirmationRegAttrFormId: 'swap-confirmation-reg-attr-form'
};

angular.module('capability-ng-scheduler').constant('ngCourseSchedulerConstant', CourseSchedulerConstant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/constants/course_scheduler_constants.ts